import React, { useEffect, Fragment } from 'react'
import { useConfiguration } from '../../hooks/useConfiguration'
import { useAuth } from 'oidc-react'
import { useUserProfile } from '../../hooks/useUserProfile'
import { getUsersWMS, postUserWMS } from '../../pages/User/config/api'
import { useSnackbar } from '../../hooks/useSnackbar'
import { SnackBar } from '../SnackBar/Snackbar'

export const ConfigurationProvider: React.FC<any> = ({ children }) => {
  const { getConfiguration } = useConfiguration()
  const { setUserProfile } = useUserProfile()
  const { isActive, isSuccess, message, openSnackBar } = useSnackbar()
  const auth = useAuth()

  useEffect(() => {
    getConfiguration()
  }, [])

  // wmse3432: en caso que el usuario inicie sesión y no exista en el wms debe crear el usuario con los datos del sso.
  useEffect(() => {
    const profile = auth.userData?.profile
    if (!profile?.email) return

    setUserProfile(profile)

    getUsersWMS(0, 1, profile.email)
      .then(({ data }) => {
        if (data?.items?.length === 0) {
          postUserWMS({
            userName: profile.email ?? '',
            userAlias: profile.name ?? profile.email ?? '',
            active: true,
            zones: []
          })
            .then(() => {
              openSnackBar(
                `Nuevo usuario: ${profile.name ?? profile.email} favor solicitar los roles correspondientes para el sistema.`,
                true
              )
            })
            .catch(() => {
              console.log('[WMS] No se pudo crear el usuario:', profile.email)
            })
        }
      })
      .catch(() => {
        console.log('[WMS] No se pudo verificar si el usuario existe:', profile.email)
      })
  }, [auth.userData])

  return (
    <Fragment>
      {children}
      <SnackBar
        open={isActive}
        message={message}
        status={isSuccess ? 'success' : 'error'}
        autoHideDuration={8000}
      />
    </Fragment>
  )
}
